module.exports = __webpack_public_path__ + "static/media/vc.4bde18df.svg";